/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open rebuy cart and exit
    const SmartCart = window.Rebuy.SmartCart;
  if(SmartCart){
    SmartCart.show();
  }
  if(document.querySelector(".openCart")){
  document.querySelector(".openCart").click()
  }
    return;

    // reset container
    document.querySelector("#miniCartContentBodyMain").innerHTML = "";

    // fetch cart
    if (!skipFetch) {
        cart = await fetch("/cart.js")
            .then(function (data) {
                return data.json();
            });
    }

    // check for free shipping is not reached
    if (cart.total_price < freeShippingThreshold) {
        // update shipping message
        document.querySelector("#miniCartContentBodyHeaderShippingTxtReached").classList.add("active");
        document.querySelector("#miniCartContentBodyHeaderShippingTxtNotReached").classList.remove("active");
        document.querySelector("#miniCartContentBodyHeaderShippingTxtNotReachedNum").innerHTML = ` ${price(freeShippingThreshold - cart.total_price)}`

        // update shipping bar
        let barWidth = ((cart.total_price / freeShippingThreshold) * 100);
        document.querySelector("#miniCartContentBodyHeaderShippingBarInner").style.width = `${barWidth}%`;

    } else {
        // update shipping message
        document.querySelector("#miniCartContentBodyHeaderShippingTxtReached").classList.remove("active");
        document.querySelector("#miniCartContentBodyHeaderShippingTxtNotReached").classList.add("active");

        // update shipping bar
        document.querySelector("#miniCartContentBodyHeaderShippingBarInner").style.width = "100%";
    }

    // update active body
    if (cart.item_count === 0) {
        document.querySelector("#miniCartContentBodyHeader").removeAttribute("data-count");
        document.querySelector("#miniCartContentBodyMain").classList.remove("active");
        document.querySelector("#miniCartContentBodyEmpty").classList.add("active");
        document.querySelector("#miniCartContentBodyFooter").classList.remove("active");
        document.querySelector("#miniCartContentBodyHeaderShipping").classList.add("active");
        document.querySelector("#miniCartContentBodyMainUpsells").classList.add("active");
        document.querySelector("#miniCartContentUpsells").classList.add("hidden");

    } else {
        document.querySelector("#miniCartContentBodyHeader").setAttribute("data-count", cart.item_count);
        document.querySelector("#miniCartContentBodyMain").classList.add("active");
        document.querySelector("#miniCartContentBodyEmpty").classList.remove("active");
        document.querySelector("#miniCartContentBodyFooter").classList.add("active");
        document.querySelector("#miniCartContentBodyHeaderShipping").classList.remove("active");
        document.querySelector("#miniCartContentBodyMainUpsells").classList.remove("active");
        document.querySelector("#miniCartContentUpsells").classList.remove("hidden");

        // update subtotal
        document.querySelector("#miniCartContentBodyFooterTotal span:last-child").textContent = price(cart.items_subtotal_price);
    }

    // append cart
    cart.items.forEach(function (item) {
        // variant HTML
        function variantHTML() {
            // loop over options_with_values
            let options = "";
            options += `<div class="miniCartContentBodyMainItemVariant">`;
            item.options_with_values.forEach(function (option) {
                options += `${option.name}: ${option.value}<br>`;
            });
            options += `</div>`;

            // check for Default
            if (options.includes("Default Title")) {
                return ""
            }

            return options;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartContentBodyMainItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        document.querySelector("#miniCartContentBodyMain").insertAdjacentHTML("beforeend", `
            <div class="miniCartContentBodyMainItem" key="${item.key}">
                <img class="miniCartContentBodyMainItemImage" src="${item.image}&width=200">
                <div>
                    <div class="miniCartContentBodyMainItemTop">
                        <div class="miniCartContentBodyMainItemTopTitle"> ${item.product_title}</div>
                        <button class="miniCartContentBodyMainItemTopTrash">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M11.8125 3.0625H2.1875" stroke="#3E454D" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M4.8125 1.3125H9.1875" stroke="#3E454D" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M10.9375 3.0625V11.375C10.9375 11.491 10.8914 11.6023 10.8094 11.6844C10.7273 11.7664 10.616 11.8125 10.5 11.8125H3.5C3.38397 11.8125 3.27269 11.7664 3.19064 11.6844C3.10859 11.6023 3.0625 11.491 3.0625 11.375V3.0625" stroke="#3E454D" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>                        
                        </button>
                    </div>
                    ${variantHTML()}
                    ${subscriptionHTML()}
                    <div class="miniCartContentBodyMainItemBottom">
                         <div class="miniCartContentBodyMainItemBottomQty">
                            <button class="miniCartContentBodyMainItemBottomQtyMinus">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M2.5 8H13.5" stroke="#3E454D" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>                                                        
                            </button>
                            <div class="miniCartContentBodyMainItemBottomQtyCount">${item.quantity}</div>
                            <button class="miniCartContentBodyMainItemBottomQtyPlus">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M2.5 8H13.5" stroke="#3E454D" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8 2.5V13.5" stroke="#3E454D" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>                            
                        </button>
                        </div>
                        <div class="miniCartContentBodyMainItemBottomPrice">${price(item.final_line_price)} <s>${item.original_line_price > item.final_line_price ? price(item.original_line_price) : ""}</s></div>
                    </div>                  
                </div>
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartContentBodyMainItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartContentBodyMainItemBottomQtyCount").textContent);

        // minus
        element.querySelector(".miniCartContentBodyMainItemBottomQtyMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartContentBodyMainItemTopTrash").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartContentBodyMainItemBottomQtyPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });


        // remove
        element.querySelector(".miniCartContentBodyMainItemTopTrash").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartContentBodyMainItemBottomQtyCount`).textContent = quantity;

            // update cart in shopify
            let response = await changeProduct({
                id: key,
                quantity: quantity
            });

            // check for error
            if (response.status === 422) {
                alert("No more in stock.");
            } else {
                cart = response;
            }

            // update active body
            await openCart(true);
        }
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartContentUpsellsBodyItemATC").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.id);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.closest(".miniCartContentUpsellsBodyItem").classList.remove("active");
        } else {
            element.closest(".miniCartContentUpsellsBodyItem").classList.add("active");
        }
    });

    // check if upsells empty (upsells have no active items)
    if (document.querySelectorAll(".miniCartContentUpsellsBodyItem.active").length === 0) {
        // hide upsells
        document.querySelector("#miniCartContentUpsells").classList.add("active");
    } else {
        document.querySelector("#miniCartContentUpsells").classList.remove("active");
    }

    // show cart
    document.querySelector("#miniCart").showModal();
    document.querySelector("#miniCart").classList.add("active");
    document.querySelector('#miniCartContent').classList.add('active');
    document.querySelector("body").classList.add("noScroll");
}


// add upsell to cart listener
document.querySelectorAll(".miniCartContentUpsellsBodyItemATC").forEach(function (element) {
    element.addEventListener("click", async function () {
        // add loading animation
        this.classList.add("loading");

        // add to cart
        await addProduct({
            id: element.dataset.product,
            quantity: 1
        });

        // open cart
        await openCart(false);

        // remove loading animation
        this.classList.remove("loading");
    });
});


// mobile upsells swiper
new Swiper('#miniCartContentBodyMainUpsellsSwiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
        nextEl: '#miniCartContentBodyMainUpsellsHeaderNavNext',
        prevEl: '#miniCartContentBodyMainUpsellsHeaderNavPrev',
    }
});

// close cart
function closeCart() {
    document.querySelector('#miniCartContent').classList.remove('active');
    document.querySelector("#miniCart").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");

    // Wait before closing - allows animation to complete
    setTimeout(function () {
        document.querySelector("#miniCart").close();
    }, 400);
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function () {
        openCart();
    });
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartContentBodyFooterCheckout").addEventListener("click", async function () {
    window.location.href = "/checkout";
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));